import { useState } from 'react';

import * as Sentry from '@sentry/nextjs';

type SetValue<T> = (value: T | ((storedValue: T) => T)) => void;

/**
 * @deprecated
 */
const useLocalStorage = <T>(key: string, initialValue: T): [T, SetValue<T>] => {
    const [storedValue, setStoredValue] = useState<T>(() => {
        try {
            const hasWindow = typeof window !== 'undefined';
            const item = hasWindow && window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (err) {
            Sentry.captureException(err);
            // eslint-disable-next-line no-console
            console.log(err);
            return initialValue;
        }
    });

    const setValue: SetValue<T> = value => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (err) {
            Sentry.captureException(err);
            // eslint-disable-next-line no-console
            console.log(err);
        }
    };

    return [storedValue, setValue];
};

export default useLocalStorage;
